import styled from "styled-components"

export default styled.div`
  display: flex;
  flex-direction: ${props => props.flexDirection || 'row'};
  align-items: ${props => props.alignItems || 'normal'};
  justify-content: ${props => props.justifyContent || 'start'};
  gap: ${props => props.gap ? `${props.gap}px` : 0};
`
